import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import FlashSales from './components/FlashSales';
import FeaturedProducts from './components/FeaturedProducts';
import PlumbingSection from './components/PlumbingSection';
import ElectricalSection from './components/ElectricalSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AdminPanel from './components/AdminPanel';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <FlashSales />
              <FeaturedProducts />
              <PlumbingSection />
              <ElectricalSection />
            </>
          } />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
